import { onAuthStateChanged, signOut } from 'firebase/auth';
import React, { useEffect } from 'react'
import { auth } from '../utils/firebase';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addUser, removeUser } from '../utils/userSlice';
import { LOGO, SUPPORTED_LANGUAGES } from '../utils/constants';
import { toggleGptSearchView } from '../utils/gptSlice';
import { changeLanguage } from '../utils/configSlice';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(store => store.user)
  const showGptSearch = useSelector((store) => store.gpt.showGptSearch)

  const handleSignout = () => {
    signOut(auth)
    .then(() => {})
    .catch((error) => {
    navigate("/error")
    });
  }

  const handleGptSearchClick = () => {
    dispatch(toggleGptSearchView())
  }

  const handleLanguageChange = (e) => {
    dispatch(changeLanguage(e.target.value))
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
    if (user) {
    // User is signed in
    const { uid, email, displayName, photoURL } = user;
    dispatch(addUser({ uid: uid, email: email, displayName: displayName, photoURL: photoURL }));
    navigate("/browse")
  } else {
    // User is signed out
    dispatch(removeUser());
    navigate("/")
    }
  });

   // Unsubscribe when component unmounts
   return () => unsubscribe();
  }, [dispatch, navigate])

  return (
    <>
    <div className='absolute w-full px-8 py-2 bg-gradient-to-b from-black z-20 flex flex-col md:flex-row justify-between'>
      <img 
      className='w-44 mx-auto md:mx-0'
      src={LOGO} alt='logo'/>
      {user && (
        <div className='flex p-2 justify-between items-center space-x-3'>
        {showGptSearch && (
          <select className='bg-gray-900 text-white p-2 m-1 rounded-lg'
          onClick={handleLanguageChange}>
          {SUPPORTED_LANGUAGES.map(lang => <option 
          key={lang.identifier} value={lang.identifier}>{lang.name}</option>)}
        </select>
        )}
        <button className='py-1 px-2 md:px-4 mx-4 bg-purple-800 text-white rounded-lg'
        onClick={handleGptSearchClick}
        >
          {showGptSearch ? "Home Page" : "GPT Search"}</button>
        <img 
        className='hidden md:block w-12 h-12'
        src={user?.photoURL} alt="userIcon" />
        <button onClick={handleSignout} className='font-bold text-black bg-white p-1 px-4 rounded-full'>Sign Out</button>
      </div>
      )}
    </div>
    </>
  )
}

export default Header
